import React from "react";
// import { Link } from "react-router-dom";




export default class AboutUs extends React.Component {

    render(){
        return(
            <div>
                <div class="wrapper">
                    <section class="bread-crumb-container">
                        <div class="bread-crumb-img">
                            <img src="/assets/images/bread-crumb5.png" alt=""/>
                        </div>
                        <div class="bread-crumb-content">
                            <div class="bread-crumb-inner">
                            <h2>aboutus</h2>
                            <a href="index.html">Home</a> - <a href="news.html">About Us</a>
                            </div>
                        </div> {/* <!-- bread-crumb-content --> */}
                    </section> {/* <!-- bread-crumb-container --> */}
                    <div class="main-part">
                        <section class="our-client-container">
                            <div class="container"> 
                                <div class="heading wow fadeInLeft" data-wow-duration="1000ms" data-wow-delay="300ms">
                                    <div class="row">
                                        <div class="text-center col-sm-12">
                                            <h2>Where Tradition Meets Wellness</h2>
                                        </div>
                                    </div> 
                                </div> {/* <!-- heading --> */}
                                <div class="our-client text-left">
                                    <div class="col-md-12 col-sm-12 col-xs-12">
                                        <div class="client-content wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="300ms">
                                            <p style={{fontSize:18}}><span class="quort">“</span>At <span style={{fontWeight:'700'}}>Village Cafe</span>, we believe food is not just about taste - it's about tradition, wellness, and togetherness. Inspired by the <span style={{fontWeight:'700'}}>age-old recipes of our grandmothers</span>, we serve dishes that are: </p>
                                        </div> {/* <!-- client-content --> */} 
                                    </div>
                                </div>
                            </div>
                        </section>
                         <section class="event-container">
                            <div class="container">
                                <div class="event-detail-wrap event-detail-noimg">
                                    <div class="event-list wow fadeInDown text-center" data-wow-duration="1000ms" data-wow-delay="300ms">
                                        <h3>Authentic :</h3>
                                        <p>Prepared with the same ingredients and methods from village kitchens.</p>
                                    </div> {/* <!-- event-list --> */}
                                </div> {/* <!-- event-wrap --> */}
                                <div class="event-detail-wrap event-detail-noimg">
                                    <div class="event-list wow fadeInDown text-center" data-wow-duration="1000ms" data-wow-delay="300ms">
                                        <h3>Healthy :</h3>
                                        <p>Featuring <span style={{fontWeight:'700'}}>millet-based breakfasts, low-oil curries</span>, and <span style={{fontWeight:'700'}}>calorie-conscious recipes</span></p>
                                    </div> {/* <!-- event-list --> */}
                                </div> {/* <!-- event-wrap --> */}
                                <div class="event-detail-wrap event-detail-noimg">
                                    <div class="event-list wow fadeInDown text-center" data-wow-duration="1000ms" data-wow-delay="300ms">
                                        <h3>Accessible :</h3>
                                        <p>Available through our <span style={{fontWeight:'700'}}>food trucks</span> and <span style={{fontWeight:'700'}}>subscription meal plans</span>.</p>
                                    </div> {/* <!-- event-list --> */}
                                </div> {/* <!-- event-wrap --> */}
                                <div style={{margin:5}}> 
                                    <span style={{fontSize:20,fontWeight:'700'}}>Our Promise : </span>
                                    <span style={{fontSize:20}}>Every plate is filled with love, wellness, and flavors that feel like home.</span>
                                </div>
                            </div>
                    </section> {/* <!-- event-container --> */}
                    <div class="map-outer">
                        <div id="truck-locator"></div>
                    </div>
                    </div> {/* <!-- main-part --> */}
                   
                </div>
            </div>
        )
    }
}